<app-header></app-header>

<div class="responsive">
  <div class="container-fluid">

    <div class="row">

      <!-- Sidebar -->
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>

      <!-- Main Content -->
      <div class="col-md-6">

        <!-- Header -->
        <div class="row margin-b">
          <div class="col-md-12">

            <app-sub-header title="Donations"></app-sub-header>

            <div class="display">

  <div style="flex:1">
    <input
      #searchInput
      type="search"
      placeholder="Search Merchant"
      class="form-control">

    
  </div>

  <div class="margin-l">

    <select
      class="form-control"
      [(ngModel)]="selectedStatus"
      (change)="onStatusChange()">

      <option value="all">All</option>
      <option value="pending">Pending</option>
      <option value="completed">Transferred</option>

    </select>

  </div>

</div>

          </div>
        </div>

        <!-- Skeleton Loader -->
        <div class="row" *ngIf="!loading">
          <div class="col-md-12">
            <div *ngFor="let item of arr">
              <app-card-skelton></app-card-skelton>
            </div>
          </div>
        </div>

        <!-- Donation List -->
        <div class="row" *ngIf="loading">

          <div class="col-md-12">

            <div
              *ngFor="let donation of (objArr | paginate : {
                itemsPerPage: pageSize,
                currentPage: pageNo,
                totalItems: totalItems
              })"
              (click)="openMerchant(donation.merchantId)"

              class="card mb-3">

              <div class="card-body">

                <div class="row">

                  <div class="col-md-2 text-center">
                    
                     <img
    *ngIf="donation.photo"
    [src]="donation.photo"
    (error)="getErrorImage($event)"
    class="img-fluid rounded-circle"
    width="60"
    height="60">

  <div
    *ngIf="!donation.photo"
    class="avatar-circle"
    [style.background]="donation.avatar.color">

    {{ donation.avatar.letter }}

  </div>
                  </div>

                  <div class="col-md-10">

                    <h5 class="mb-2">
                      {{ donation.name }}
                    </h5>

                    <p class="mb-1">
                      <strong>Donation:</strong>
                      ${{ donation.donationAmount }}
                    </p>

                    <p class="mb-1">
                      <strong>Subscription:</strong>
                      ${{ donation.subscriptionAmount }}
                    </p>

                    <p class="mb-1">
                      <strong>Date:</strong>
                      {{ donation.date | date:'mediumDate' }}
                    </p>

                    <p class="mb-0">
                      <strong>Status:</strong>

                      <span
                        class="badge badge-success"
                        *ngIf="donation.status=='Transferred'">
                        Transferred
                      </span>

                      <span
                        class="badge badge-warning"
                        *ngIf="donation.status=='Pending'">
                        Pending
                      </span>

                    </p>

                  </div>

                </div>

              </div>

            </div>

            <!-- No Results -->
            <app-no-results-found
              *ngIf="objArr.length == 0"
              title="Donations">
            </app-no-results-found>

            <!-- Pagination -->
            <div
              class="text-center"
              *ngIf="totalItems > pageSize">

              <pagination-controls
                class="my-pagination"
                (pageChange)="getDonations($event)"
                directionLinks="true"
                autoHide="false"
                responsive="true"
                previousLabel="Previous"
                nextLabel="Next">
              </pagination-controls>

            </div>

          </div>

        </div>

      </div>

      <!-- Upcoming Events -->
      <div class="col-md-3">
        <app-events [showheader]="true"></app-events>
      </div>

    </div>

  </div>
</div>